module.exports = __webpack_public_path__ + "static/media/swirl-yellow.ad5a19ba.svg";